module.exports = "data:application/font-woff;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmYzc4NzU5ZTkzYTZjYWM1MDQ1ODYxMGUzZDlkNjNhMC53b2ZmIjs="


//////////////////
// WEBPACK FOOTER
// ../~/materialize-css/fonts/roboto/Roboto-Medium.woff
// module id = 451
// module chunks = 0